import React from "react"
import { AppFunctionComponent } from "../../types"
import styled from "styled-components"

type ShowOnlyOnProps = {
  showOnlyOn?: "desktop" | "mobile"
  children: React.ReactNode
}

const ShowOnlyOn: AppFunctionComponent<ShowOnlyOnProps> = ({
  showOnlyOn,
  children,
}) => {
  switch (showOnlyOn) {
    case "desktop":
      return <DesktopView>{children}</DesktopView>
    case "mobile":
      return <MobileView>{children}</MobileView>
    default:
      return <>{children}</>
  }
}

export default ShowOnlyOn

const DesktopView = styled.div`
  display: block;
  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: none;
  }
`

const MobileView = styled.div`
  display: block;
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: none;
  }
`
